export const PROPERTY_TYPE_OPTIONS = [
  { name: "House", value: "house" },
  { name: "Flat", value: "flat" },
];

export const BEDROOMS_OPTIONS = [
  { name: "1", value: "1" },
  { name: "2", value: "2" },
  { name: "3", value: "3" },
  { name: "4", value: "4" },
  { name: "5+", value: "5+" },
];

export const SELLING_TIMEFRAME_OPTIONS = [
  { name: "0-3 months", value: "0-3 months" },
  { name: "3-6 months", value: "3-6 months" },
  { name: "6-12 months", value: "6-12 months" },
  { name: "Not sure", value: "Not sure" },
];

// Helper function to get display name from value
export function getDisplayName(options: { name: string; value: string }[], value: string | undefined): string | null {
  if (!value) return null;
  const option = options.find((opt) => opt.value === value);
  return option ? option.name : null;
}
